import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { SharedModule } from './modules/shared/shared.module';
import { MSAL } from './util/msal.config';

import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from "@sentry/angular";
import { APP_INSIGHTS, ENV_CONFIG, EnvironmentConfig } from '../environments/environment.model';
import { HeaderComponent } from './layouts/header/header.component';
import { TopNavComponent } from './layouts/top-nav/top-nav.component';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { SearchResultComponent } from './modules/search/search-result/search-result.component';
import { appInitializer } from './resolvers/app-initializer';
import * as fromEffects from './store/effects';
import { metaReducers, reducers } from './store/reducers';
import { DndDirective } from './util/dnd.directive';
import { Logger } from './util/logger';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './layouts/footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    HeaderComponent,
    TopNavComponent,
    SearchResultComponent,
    DndDirective,
    MessageModalComponent,
    SidebarComponent,
    FooterComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true
      }
    }),
    EffectsModule.forRoot([
      fromEffects.AppEffects,
      fromEffects.FittingsEffects,
      fromEffects.ClosuresEffects,
      fromEffects.SearchEffects,
      fromEffects.PigEffects,
      // fromEffects.AdminEffects,
      fromEffects.PigProductGuideEffects,
      fromEffects.PeEffects,
      fromEffects.PigSigEffects,
      fromEffects.MessagesEffects,
      fromEffects.FailureEffects
    ]),

    StoreRouterConnectingModule.forRoot(),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    NgbModule
  ],
  providers: [
    MSAL,
    { provide: ENV_CONFIG, useValue: environment },
    {
      provide: APP_INSIGHTS, useFactory: (env: EnvironmentConfig) =>
        new ApplicationInsights({
          config: {
            instrumentationKey: env.appInsights.instrumentationKey,
            enableAutoRouteTracking: true
          }
        }), deps: [ENV_CONFIG]
    },
    Logger,
    { provide: Window, useValue: window },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    { provide: APP_INITIALIZER, useFactory: () => () => { }, multi: true, deps: [Sentry.TraceService] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
